import { render, staticRenderFns } from "./SupportDialog.vue?vue&type=template&id=58cf6a98&scoped=true"
import script from "./SupportDialog.vue?vue&type=script&lang=js"
export * from "./SupportDialog.vue?vue&type=script&lang=js"
import style0 from "./SupportDialog.vue?vue&type=style&index=0&id=58cf6a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cf6a98",
  null
  
)

export default component.exports